"use client"

import { List, Separator } from "@opensea/ui-kit"
import { AccountSwitcherAccountItemsSkeleton } from "@/components/navigation/top-nav/account-switcher/AccountSwitcherAccountItemsSkeleton"

type Props = {
  count?: number
  showList?: boolean
}

/**
 * Shared skeleton component for wallet lists
 */
export function LinkedWalletsSkeletons({ count = 3, showList = true }: Props) {
  const skeletonItems = Array.from({ length: count }, (_, index) => (
    <div key={index}>
      <AccountSwitcherAccountItemsSkeleton />
      {index < count - 1 && <Separator />}
    </div>
  ))

  if (!showList) {
    return <>{skeletonItems}</>
  }

  return (
    <List
      className="rounded-lg border border-border-1 bg-bg-primary"
      showBorder={false}
    >
      {skeletonItems}
    </List>
  )
}
